const state = {
    userName: '',
    userId: '',
    type: '',
    typeName: ''
}

const mutations = {
    setUserName(state, name) {
        state.userName = name
    },
    setUserId(state, userId) {
        state.userId = userId
    },
    setType(state, type) {
        state.type = type
    },
    setTypeName(state, typeName) {
        state.typeName = typeName
    }
}

const getters = {
    userName: (state, getters) => {
        return (state) => state.userName
    },
    // userId: (state, getters) => {
    //     return (state) => state.userId
    // },
    type: (state, getters) => {
        return (state) => state.type
    },
    typeName: (state, getters) => {
        return (state) => state.typeName
    }
    //getUserName: (state) => state.userName,
    //getUserId: (state) => state.UserId,
}

const actions = {
    setUser({ state, commit }, obj) {
        console.log(obj)
        commit('setUserName', obj.data.name);
        commit('setType', obj.data.type);
        commit('setTypeName', obj.data.typeName);
        // commit('setUserId', obj.data.userid);
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}